exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n/** \n* Пагинация =====================================================\n*/\n/**\n* Хлебные крошки\n*/\n.estimate-container[data-v-da341650] {\n  max-width: 1479.98px;\n  margin: auto;\n}", ""]);

// exports
